export { r as rubberbandIfOutOfBounds } from '../../dist/maths-0ab39ae9.esm.js';
